const INIT_TRAININGS = (state, payload) => state.trainings = payload.trainings;

const INIT_TRAINING_SESSIONS = (state, payload) => state.trainingSessions = payload.trainingSessions;

const INIT_SESSION_PARTICIPANTS = (state, payload) => state.sessionParticipants = payload.sessionParticipants;
                
const INIT_LATEST_QUIZ_RESPONSES = (state, payload) => state.latestQuizResponses = payload.latestQuizResponses;

const INIT_LATEST_EVALUATION_RESPONSES = (state, payload) => state.latestEvaluationResponses = payload.latestEvaluationResponses;

const ADD_NEW_SESSION = (state, payload) => {
    // add session id to sessions array in training object
    state.trainings[payload.trainingId].session_id_list.push(payload.trainingSessionId);

    // update trainingSessions object in store
    state.trainingSessions[payload.trainingSessionId] = {...payload.trainingSession, isNew: payload.isNew};
}

const UPDATE_TRAINING_SESSION = (state, payload) => {
    state.trainingSessions[payload.trainingSessionId] = payload.trainingSession;
}

const UPDATE_SESSION_PARTICIPANTS = (state, payload) => {
    state.sessionParticipants[payload.trainingSessionId] = payload.sessionParticipants;
}

const UPDATE_LATEST_QUIZ_RESPONSE = (state, payload) => {
    state.latestQuizResponses[payload.trainingSessionId] = payload.latestQuizResponse;
}

const UPDATE_LATEST_EVALUATION_RESPONSE = (state, payload) => {
    state.latestEvaluationResponses[payload.trainingSessionId] = payload.latestEvaluationResponse;
}

const UPDATE_IS_QUIZ_LOADING = (state, payload) => {
    state.isQuizLoading = payload.isQuizLoading;
}

const SET_CURRENT_TRAINING_ID = (state, payload) => {
    state.currentTrainingId = payload.currentTrainingId;
}

const SET_SHOW_ADD_TRAINING_SESSION = (state, payload) => {
    state.showAddTrainingSession = payload.showAddTrainingSession;
}

const SET_CURRENT_TRAINING_SESSION = (state, payload) => {
    state.currentTrainingSession = payload.currentTrainingSession;
}

const SET_CURRENT_CONTENT_COMPONENT = (state, payload) => {
    state.currentContentComponent = payload.currentContentComponent;
}

const SET_SHOW_CONTENT = (state, payload) => {
    state.showContent = payload.showContent;
}

export default {
    INIT_TRAININGS,
    INIT_TRAINING_SESSIONS,
    INIT_SESSION_PARTICIPANTS,
    INIT_LATEST_QUIZ_RESPONSES,
    INIT_LATEST_EVALUATION_RESPONSES,
    ADD_NEW_SESSION,
    UPDATE_TRAINING_SESSION,
    UPDATE_SESSION_PARTICIPANTS,
    UPDATE_LATEST_QUIZ_RESPONSE,
    UPDATE_LATEST_EVALUATION_RESPONSE,
    UPDATE_IS_QUIZ_LOADING,
    SET_CURRENT_TRAINING_ID,
    SET_SHOW_ADD_TRAINING_SESSION,
    SET_CURRENT_TRAINING_SESSION,
    SET_CURRENT_CONTENT_COMPONENT,
    SET_SHOW_CONTENT
}